/* Kendi Tablonu Tasarla: ONIZLEMEDE CERCEVE (Claude, 16 Eylul 2026, 3. surum).

   Kullanici: "galeri cercevesi yine ayni, sadece kalinlastiriyorsun; gercek
   cercevede detaylar var". 2. surumde bant genisligi dogruydu ama yuzey duzdu.
   Bu surumde bant GERCEK BIR PROFIL gibi ciziliyor:
     - kose gonyesi: conic-gradient'in dort dilimi tam kosegenlerde birlesir,
       yani her kosede 45 derecelik birlesim cizgisi olusur (gercek cerceveler
       gonyeli kesilir),
     - kenar isigi: ust kenar acik, alt kenar koyu, yanlar arada - tek yonlu
       isik altindaki ahsap profilin davranisi,
     - ic kademe (rabbet): bandin ic kenarinda once ince acik pah, sonra
       posterin uzerine dusen yumusak golge,
     - dis kenar: ince koyu hat, profilin bittigi yer.
   Tuvalin cizimine dokunulmuyor; her sey tuvali saran kat uzerinde.

   Bant olculeri urun sayfasindaki tanimlarla ayni:
     Basic / Derin  on serit 2 cm   (fark golgede: 1,5 cm - 3,5 cm duvardan)
     Galeri         on serit 8 cm   (yalniz siyah)
*/
(function () {
  var PALET = {
    siyah: { taban: "#1f1a17", acik: "#3a322c", koyu: "#0f0c0a", pah: "rgba(255,255,255,.16)" },
    beyaz: { taban: "#efece5", acik: "#fbf9f4", koyu: "#cfc9bf", pah: "rgba(255,255,255,.75)" },
    /* Renkli Basic cerceveler (2 Ekim 2026). Kullanici: "neyi sectigini
       anlamiyorsun". Onizleme yalniz siyah/beyaz biliyordu, Kirmizi secilince
       cerceve siyah kaliyordu. Tonlar custom-poster.js MOCKUP_PALET ile ayni. */
    ceviz:   { taban: "#5c2b23", acik: "#6b3128", koyu: "#40201c", pah: "rgba(255,255,255,.16)" },
    kirmizi: { taban: "#c2141b", acik: "#d3242a", koyu: "#9c0b12", pah: "rgba(255,255,255,.22)" },
    pembe:   { taban: "#d97cae", acik: "#e58cbd", koyu: "#c05c96", pah: "rgba(255,255,255,.45)" },
    sari:    { taban: "#f5c707", acik: "#ffd83a", koyu: "#e0ab00", pah: "rgba(255,255,255,.5)" }
  };
  /* Radyo degeri -> palet anahtari. Turkce I yuzunden lower() yok. */
  var ANAHTAR = { "Siyah": "siyah", "Beyaz": "beyaz", "Ceviz": "ceviz",
                  "Kırmızı": "kirmizi", "Pembe": "pembe", "Sarı": "sari" };

  function secili(ad) {
    var s = document.querySelector('input[name="' + ad + '"]:checked');
    return s ? s.value : null;
  }

  function kat(tuval) {
    var k = tuval.parentElement;
    if (k && k.classList.contains("cp-cerceve-kat")) return k;
    k = document.createElement("span");
    k.className = "cp-cerceve-kat";
    k.style.display = "block";
    k.style.boxSizing = "border-box";
    k.style.maxWidth = "100%";
    k.style.position = "relative";
    tuval.parentElement.insertBefore(k, tuval);
    k.appendChild(tuval);
    return k;
  }

  function uygula() {
    var tuval = document.querySelector(".cp-canvas-box canvas");
    if (!tuval) return;
    var k = kat(tuval);
    var model = secili("cp-cerceve-modeli") || "Basic";
    var galeri = model === "Galeri";
    var anahtar = galeri ? "siyah" : (ANAHTAR[secili("cp-cerceve") || "Siyah"] || "siyah");
    var p = PALET[anahtar];
    var beyaz = anahtar !== "siyah" && anahtar !== "ceviz";   // acik tonlu: dis hat ve golge yumusak
    var en = tuval.getBoundingClientRect().width || 400;
    var bant = Math.max(6, Math.round(en * (galeri ? 0.115 : 0.032)));
    var pah = Math.max(1, Math.round(bant * 0.14));      // ic kademe pahi
    var golge = Math.max(2, Math.round(bant * 0.30));    // posterin uzerine dusen golge

    k.style.padding = bant + "px";
    /* KOSE GONYESI + KENAR ISIGI: conic-gradient'in dilim sinirlari karenin
       kosegenleridir; dort kenar ayri ton alinca kose birlesimi kendiliginden
       cikar. Baslangic 45 derece: ilk dilim UST kenar. */
    k.style.background =
      "conic-gradient(from 45deg at 50% 50%, " +
      p.acik + " 0deg 90deg, " +      // ust: isik alan yuz
      p.taban + " 90deg 180deg, " +   // sag
      p.koyu + " 180deg 270deg, " +   // alt: golgede kalan yuz
      p.taban + " 270deg 360deg)";    // sol
    k.style.boxShadow = [
      "inset 0 0 0 1px " + (beyaz ? "rgba(92,80,66,.45)" : "rgba(0,0,0,.65)"),      // dis hat
      "inset 0 0 0 " + (bant - pah) + "px transparent",                              // yer tutucu
      "inset 0 0 0 " + bant + "px rgba(0,0,0,0)",                                    // (bos)
      galeri
        ? "8px 14px 0 -2px rgba(0,0,0,.34), 0 30px 55px rgba(40,30,20,.45)"
        : model === "Derin"
        ? "5px 9px 0 -2px rgba(0,0,0,.30), 0 20px 38px rgba(40,30,20,.38)"
        : "0 14px 30px rgba(65,42,29,.22)"
    ].join(", ");

    /* IC KADEME: bandin ic kenarinda once ince acik pah, sonra posterin
       uzerine dusen yumusak golge. Ayri bir katman olarak ciziliyor cunku
       box-shadow inset'i tuvalin (opak) uzerine dusmuyor. */
    var ic = k.querySelector(":scope > .cp-cerceve-ic");
    if (!ic) {
      ic = document.createElement("span");
      ic.className = "cp-cerceve-ic";
      ic.setAttribute("aria-hidden", "true");
      ic.style.position = "absolute";
      ic.style.pointerEvents = "none";
      k.appendChild(ic);
    }
    ic.style.inset = (bant - pah) + "px";
    ic.style.border = pah + "px solid " + p.pah;
    ic.style.boxSizing = "border-box";
    ic.style.boxShadow = "inset 0 0 " + golge + "px " + Math.round(golge * 0.55) + "px rgba(0,0,0," + (beyaz ? ".28" : ".55") + ")";

    tuval.style.border = "0";
    tuval.style.outline = "";
    tuval.style.boxShadow = "none";
    tuval.style.display = "block";
    tuval.style.maxWidth = "100%";
    tuval.style.position = "relative";
    tuval.style.zIndex = "0";
  }

  function planla() { setTimeout(uygula, 60); }

  document.addEventListener("change", function (e) {
    if (e.target && /^cp-cerceve/.test(e.target.name || "")) planla();
  }, true);
  document.addEventListener("click", planla, true);
  window.addEventListener("resize", planla);
  if (document.body) new MutationObserver(planla).observe(document.body, { childList: true, subtree: true });
  planla();
})();
